/**
 * Térkép megjelenítő komponens modul
 * @author Erik Banhalmi 2017.06.27.
 */
import angular from 'angular';
import 'ngmap';

import { RealEstateMapComponent } from './real-estate-map.componenet';

const MODULE_NAME = 'RealEstateMap';

export default angular.module(MODULE_NAME, ['ngMap']).component('realEstateMap', RealEstateMapComponent).name;


